export type { PromotionHeaderProps } from './ PromotionHeader.types';
export { default } from './ PromotionHeader';
